import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
};
const defaultProps = {
  className: ''
};

class Button extends Component {
  onClick = () => {
    const { onClick } = this.props;

    if (onClick) onClick();
  };

  render() {
    const { className, label, loading, disabled } = this.props;

    return (
      <button
        disabled={disabled}
        onClick={this.onClick}
        className={`button-wrapper ${className} ${loading ? 'loading' : ''}`}
      >
        <span>{label}</span>
      </button>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
